import { useQuery } from "@tanstack/react-query";

import { devtoolsApi } from "./api.ts";
import { HealthStatus } from "./health-status.tsx";

export function ApiHealthDevtoolPanel() {
	const query = useQuery({
		...devtoolsApi.getHealthzOptions(),
	});

	if (query.isPending) return null;

	return <HealthStatus data={query.data!} />;
}
